<template>
  <div>
    <v-toolbar flat color="white" clas="pt-3">
      <h2 class="grey--text px-2 py-2">{{contact.name+ ' '+ contact.surname}}</h2>
    </v-toolbar>
 
  </div>
</template>

<script>
import Api from "@/services/Api";
import LocationSearchModal from "@/components/Locations/locationSearchModal.vue";


export default {
  props: ["contact","linkedLocations"],
  components: {
      locationsearchmodal: LocationSearchModal
      
  },
  watch:{
      contactTypeId(value){
          if(value!==null&&typeof value !=='undefined'&&value>0){
              this.locationSearchModal=true
          }
      },
      '$route.query.selectedLocation': {
          immediate: true,
          handler(value){
              if(value&&value!==null&value!==''&&this.contactTypeId>0){
                  Api()
            .post("/locationContact",{
                locationId: this.$route.query.selectedLocation,
              contactId: this.$route.params.contactId,
              contactTypeId: this.contactTypeId,
              isDeleted: false,
              isActive: true
            })
            .then(response => {
              this.$emit('contactChange')
              this.locationSearchModal=false
              this.associateContactModal=false
      })
              }
              
          }
      }
  },
  data() {
    return {
            name: "",
            associateContactModal: false,
            
            contactTypes:[],
            contactTypeId: 0,
            totalItems: null,
            customerId: null,
            locations:[],
            locationSearchModal: false,
            isloading:true,
            loading: false, 
            expand: false,
            search: "",
            dialog: false,
            newDialog: false,
            pagination: {},
            editedIndex: -1,
            editedItem: {
      name: "",
      isActive: true,
      isDeleted: ""
    },
    defaultItem: {
      name: "",
      isActive: true,
      isDeleted:""
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ],
    editedItem:{},
      locationNodes: [],
      switchingCentreDevices: [],
      salesValue: "",
      cosValue: "",
      expenseValue: "",
      loanValue: "",
      totals: [],
      switchingCentreTransactions: [],
      switchingCentreInfo: [],
      descriptionList:[],
      activeTabName:'',
      tabs: [        
        { name: "information", displayName: "Contact Information" },
        { name: "locations", displayName: "Linked Locations" },
        { name: "transactions", displayName: "Transactions" }             
      ]
    };
  },
  created() {
      this.initialize()
  },
  async mounted() {
      this.setActiveTabName('nodes')
  },
  computed: {
         pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
    },
  methods: {
      initialize(){
      },
      
      associateContact(){
        if(this.authUpdate(this.$store.state.currentRoute)){ 
          Api()
            .post("/locationContacts",{
                locationId: this.$route.query.selectedLocation,
              contactId: this.$route.params.contactId,
              contactTypeId: this.contactTypeId,
              isDeleted: false,
              isActive: true
            })
            .then(response => {
              this.$emit('contactChange')
              this.locationSearchModal=false
      })}
      },
      async fetchContactTypes() {
      await Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data;
        });
    },
      async fetchLocationNetworks(){
      },
      removeContact(item) {
        if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      Api()
        .put("/LocationContact/" + this.editedItem.id, {
          locationId: this.editedItem.locationId,
          contactId: this.editedItem.contactId,
          contactTypeId: this.editedItem.contactTypeId,
          isDeleted: true,
          isActive: false
        })
        .then(response => {
          this.$emit('contactChange')
        });
        }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
      
     routerLinkToDetails(item) {
    //   this.editedItem = Object.assign({}, item);
      this.$router.push({
        path:
          "/locationnetworks/" +
          item.location.locationNetworkId +
          "/" +
          item.locationId
      });
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){ 
      this.editedIndex = this.locationNodes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      }
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/locationnodes/" + this.editedItem.id, {
          isActive: false,
          isDeleted: true
        }).then(response=>
        {    this.fetchLocationNodes() 
        })        
        },
        cancelFields(){
          this.editedItem.name=""
        },
    close() {
      this.dialog = false;
      this.newDialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },
    save() {      
    },
      saveNew() {     
  }}
};
</script>
